<!--
 * @Author: 仙道
 * @Date: 2022-04-23 17:35:44
 * @LastEditTime: 2022-04-23 19:38:57
 * @email: hao.li08@weimob.com
 * @Description: 履历
 * @FilePath: /iplus-iwt-fe/src/views/equipment/account/modules/tabs/RecordInfo.vue
-->
<template>
  <div>履历</div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'RecordInfo',
    components: {

    },
    // 定义属性
    data () {
      return {

      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {

    }
  }
</script>

<style lang='scss' scoped>


</style>
